var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nested-options-section",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("editNestedSelections")
        },
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.$emit("editNestedSelections")
        },
      },
    },
    [
      _vm._l(
        _vm.nestedSelections,
        function (nestedOptionGroup, nestedOptionGroupTitle) {
          return _c("div", { key: nestedOptionGroupTitle }, [
            _vm._v("\n\t\t" + _vm._s(nestedOptionGroupTitle) + "\n\t\t"),
            _c(
              "div",
              { staticClass: "nested-options-selected" },
              _vm._l(nestedOptionGroup.selections, function (selection, j) {
                return _c("div", { key: j, staticClass: "option-text" }, [
                  _vm._v(
                    "\n\t\t\t\t♦ " + _vm._s(selection.optionName) + "\n\t\t\t"
                  ),
                ])
              }),
              0
            ),
          ])
        }
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "nested-edit-selections-footer",
          attrs: { "aria-label": `Edit Options for ${_vm.parentLabel}` },
        },
        [
          _c("span", { staticClass: "nested-edit-selections-text" }, [
            _vm._v("Edit Selections"),
          ]),
          _vm._v(" "),
          _c("i", {
            staticClass: "fas fa-chevron-right edit-selections-chevron",
          }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }